/* global axios */
import ApiClient from './ApiClient';

class ScheduledMessageApi extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  get accountUrl() {
    return this.baseUrl();
  }

  create(conversationId, params) {
    return axios.post(
      `${this.accountUrl}/conversations/${conversationId}/scheduled_messages`,
      params
    );
  }

  get(conversationId) {
    return axios.get(
      `${this.accountUrl}/conversations/${conversationId}/scheduled_messages`
    );
  }

  getAll() {
    return axios.get(`${this.accountUrl}/scheduled_messages`);
  }

  bulkCreate(params) {
    return axios.post(
      `${this.accountUrl}/scheduled_messages/bulk_create`,
      params
    );
  }

  getBulkBatches() {
    return axios.get(`${this.accountUrl}/scheduled_messages/bulk_batches`);
  }

  getBulkPreview(labelId, inboxId) {
    return axios.get(`${this.accountUrl}/scheduled_messages/bulk_preview`, {
      params: { label_id: labelId, inbox_id: inboxId },
    });
  }

  pauseBulk(batchId) {
    return axios.post(`${this.accountUrl}/scheduled_messages/bulk_pause`, {
      batch_id: batchId,
    });
  }

  resumeBulk(batchId) {
    return axios.post(`${this.accountUrl}/scheduled_messages/bulk_resume`, {
      batch_id: batchId,
    });
  }

  cancelBulk(batchId) {
    return axios.post(`${this.accountUrl}/scheduled_messages/bulk_cancel`, {
      batch_id: batchId,
    });
  }

  update(conversationId, messageId, params) {
    return axios.patch(
      `${this.accountUrl}/conversations/${conversationId}` +
        `/scheduled_messages/${messageId}`,
      params
    );
  }

  delete(conversationId, messageId) {
    return axios.delete(
      `${this.accountUrl}/conversations/${conversationId}` +
        `/scheduled_messages/${messageId}`
    );
  }

  deleteById(messageId) {
    return axios.delete(`${this.accountUrl}/scheduled_messages/${messageId}`);
  }
}

export default new ScheduledMessageApi();
